<template>
  <div class="typeahead">

    <!--    <span v-if="loading">loading</span>-->

    <!--    <template v-else>-->
    <!--      <font-awesome-icon v-show="isEmpty" icon="search" class="icon"/>-->
    <!--      <font-awesome-icon v-show="isDirty" icon="times" @click="reset" class="icon"/>-->
    <!--    </template>-->

    <b-input-group>
      <b-form-input type="text"
                    ref="input"
                    :disabled="disabled"
                    :placeholder="inputOptions.placeholder"
                    autocomplete="off"
                    v-model="query"
                    @focus="onInputFocus"
                    @keydown.down="down"
                    @keydown.up="up"
                    @keydown.enter="hit"
                    @keydown.esc="reset"
                    @blur="onBlur"
                    @input="update"/>
      <b-input-group-append>
        <b-button variant="primary" :disabled="loading || disabled" tabindex="-1">
          <font-awesome-icon v-if="!loading" icon="search" class="icon"/>
          <b-spinner v-else small label="Spinning"></b-spinner>
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <div class="results-ctr">
      <ul class="result-list shadow" v-show="hasItems">
        <li v-for="(item, $item) in items" :class="activeClass($item)" class="py-1 px-3" @mousedown="hit"
            @mousemove="setActive($item)">
          {{displayItem(item)}}
        </li>
      </ul>
      <div class="no-results shadow" v-show="isFocused && query && requestMade && !hasItems">
        <template v-if="!$slots['no-data-found']">
          {{notFoundMessage}}
        </template>
        <slot name="no-data-found"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import VueTypeahead from 'vue-typeahead'
  import i18n from "../../../shared/i18n";

  export default {
    name: "Typeahead",
    extends: VueTypeahead, // vue@1.0.22+

    props: {
      src: {
        type: String,
        required: true
      },
      displayField: {
        type: String,
        required: true
      },
      valueField: {
        type: String,
        default: ''
      },
      options: {
        type: Object,
        default: () => {
          return {queryParamName: 'q', limit: 5, minChars: 1, data: {}}
        }
      },
      inputOptions: {
        type: Object,
        default: () => {
          return {
            placeholder: '',
            class: ''
          }
        }
      },
      notFoundMessage: {
        type: String,
        default: i18n.t('No Data Found')
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isFocused: false,
        requestMade: false,
        value: '',

        // The data that would be sent by request
        // (optional)
        data: {},

        // Limit the number of items which is shown at the list
        // (optional)
        limit: 5,

        // The minimum character length needed before triggering
        // (optional)
        minChars: 1,

        // Highlight the first item in the list
        // (optional)
        selectFirst: true,

        // Override the default value (`q`) of query parameter name
        // Use a falsy value for RESTful query
        // (optional)
        queryParamName: 'someAttribute'
      }
    },
    computed: {},
    methods: {
      getQuery() {
        return this.query;
      },
      onBlur() {
        setTimeout(() => {
          this.isFocused = false;
        }, 200);
        this.reset();
      },
      reset() {
        this.items = [];
        this.loading = false;
      },
      focus() {
        this.$refs.input.focus();
      },
      clear(){
        this.query = '';
      },
      onInputFocus() {
        this.isFocused = true;
      },
      displayItem(item) {
        const matches = this.displayField.match(/\{([^}]+)\}/g);
        if (!matches) {
          return item[this.displayField]
        }
        let content = this.displayField;
        matches.forEach(match => {
          const field = match.replace(/[\{\}]/g, '');
          content = content.replace(match, item[field]);
        });
        return content;
      },
      // The callback function which is triggered when the user hits on an item
      // (required)
      onHit(item) {
        this.query = this.displayItem(item);
        let value = item;
        if (this.valueField !== '') {
          value = item[this.valueField];
        }
        this.requestMade = false;
        this.items = [];
        this.$emit('input', value);
      },
      prepareResponseData(data) {
        this.requestMade = true;
        return data.results;
      }
    },
    mounted() {
      this.queryParamName = this.options.queryParamName;
      this.minChars = this.options.minChars;
      this.limit = this.options.limit;
      this.data = this.options.data;
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/variables";

  .typeahead {
    position: relative;
  }

  .results-ctr {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 3;
    background: white;
  }

  .result-list {
    list-style: none;
    padding: 0;

    > li {
      padding: 16px 32px;

      &.active {
        background-color: $primary;
        color: white;
      }
    }
  }

  .no-results {
    padding: 10px 12px;
  }
</style>
